<template>
	<dms-button :class="[className, { 'btn-tiptap--text': !isImage }]" :type="isActive ? 'success' : null" class="btn-tiptap" plain foo="bar"
		@click="$emit('onClick')">
		<svg v-if="isImage" class="svg-icon">
			<use :xlink:href="'#icon--' + name" />
		</svg>
		<template v-else>
			{{ name }}
		</template>
	</dms-button>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsRichTextButton',
	props: {
		className: { type: String, default: 'menubar__button' },
		isActive: Boolean,
		name: String,
		isImage: { type: Boolean, default: true },
	},
	computed: {
		src() {
			return `/assets/tiptap/icons/${this.name}.svg`;
		},
	},
});
</script>
